export default {
  buttonTooltip: 'Background Effects',
  title: 'Effects and Backgrounds',
  blurEffects: {
    title: 'Blur',
    none: 'None',
    slightBlur: 'Slight Blur',
    blur: 'Blur',
  },
  customBackgroundEffects: {
    title: 'Background',
    previewAlt: 'Uploading background',
    uploading: 'Uploading image…',
    uploadLabel: 'Custom',
    deleteImageTitle: 'Delete image?',
    deleteImageConfirm: 'Yes',
    deleteImageCancel: 'No',
    info:
      'Upload upto 3 background images in potrait orientation. Other orientations will be cropped to fit the video orientation.',
  },
  virtualBackgrounds: {
    title: 'Virtual Backgrounds',
    backgroundLoadError: 'Could not load background. Please try again.',
  },
  errors: {
    videoNotSupported: 'Background effects not supported in this browser',
    uploadFailed: 'Upload failed',
    fileTypeError: 'Only JPEG and PNG images are accepted.',
    fileSizeError: 'File exceeds the 5 MB limit. Please choose a smaller image.',
    invalidFile: 'Invalid file. Please try again.',
    saveError: 'Could not save the image. Please try again.',
  },
};
